import React from 'react';
import { Navbar } from '../components/homepage/Navbar';
import { HeroSection } from '../components/homepage/HeroSection';
import { CausesSection } from '../components/homepage/CausesSection';
import { PillarsSection } from '../components/homepage/PillarsSection';
import { HowItWorks } from '../components/homepage/HowItWorks';
import { WhyBillvast } from '../components/homepage/WhyBillvast';
import { Footer } from '../components/homepage/Footer';
export const Homepage: React.FC = () => {
  return <div className="min-h-screen bg-white font-sans text-brand-text-dark selection:bg-brand-primary/20 selection:text-brand-primary-dark" data-id="element-1185">
      <Navbar data-id="element-1186" />
      <main data-id="element-1187">
        <HeroSection data-id="element-1188" />
        <CausesSection data-id="element-1189" />
        <PillarsSection data-id="element-1190" />
        <HowItWorks data-id="element-1191" />
        <WhyBillvast data-id="element-1192" />
      </main>
      <Footer data-id="element-1193" />
    </div>;
};